<div class="ac-page">

  <!-- Toolbar -->
  <div class="ac-toolbar">
    <div class="ac-toolbar__fields">
      <mat-form-field appearance="outline" class="rt-months-field" style="min-width:200px">
        <mat-label>Meses</mat-label>
        <mat-select [formControl]="monthControl" multiple (selectionChange)="onChangeMonth($event)" #monthSelect>
          <mat-checkbox (change)="onSelectAll($event)" class="ps-3" [(ngModel)]="allMonthsSelected">Todos</mat-checkbox>
          <mat-select-trigger>
            <span>{{ allMonthsSelected ? 'Todos' : getSelectedMonthsNames() }}</span>
          </mat-select-trigger>
          <mat-option *ngFor="let card of monthList; trackBy: trackByIndex" [value]="card.number">{{ card.name }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-slide-toggle [(ngModel)]="showGlobal" (change)="getData()">
        Todas las actividades
      </mat-slide-toggle>
    </div>
  </div>

  <!-- Loading -->
  <div class="ac-loading" *ngIf="!resumeloading">
    <div class="ac-loading__icon"><mat-icon>show_chart</mat-icon></div>
    <div class="ac-loading__dots"><span></span><span></span><span></span></div>
    <p class="ac-loading__text">Cargando informe…</p>
  </div>

  <!-- Tabla de resultados -->
  <ng-container *ngIf="resumeloading">
    <div class="ac-table-wrap">
      <table class="fin-table">
        <thead>
          <tr>
            <th style="padding:12px 16px;background:#1e2235;color:rgba(255,255,255,0.87);font-size:12px;text-transform:uppercase;letter-spacing:.05em;text-align:left">
              INFORME SOBRE RESULTADOS
            </th>
            <th style="padding:12px 16px;background:#1e2235;color:rgba(255,255,255,0.87);font-size:12px;text-transform:uppercase;letter-spacing:.05em;text-align:right;min-width:160px">
              Importe
            </th>
            <th style="padding:12px 16px;background:#1e2235;color:rgba(255,255,255,0.87);font-size:12px;text-transform:uppercase;letter-spacing:.05em;text-align:right;min-width:80px">
              %
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Ingresos</td>
            <td style="text-align:right;font-variant-numeric:tabular-nums">{{ summaryResult.income | currency:'EUR':'symbol':'1.2-2':'es' }}</td>
            <td style="text-align:right"></td>
          </tr>
          <tr>
            <td>Compras</td>
            <td style="text-align:right;font-variant-numeric:tabular-nums">{{ summaryResult.purchases | currency:'EUR':'symbol':'1.2-2':'es' }}</td>
            <td style="text-align:right;color:#6b7280">{{ getPositivePercentage(summaryResult.purchases, summaryResult.income) | percent:'1.0-0' }}</td>
          </tr>
          <tr class="fin-table__result">
            <td>MARGEN BRUTO</td>
            <td>{{ summaryResult.grossMargin | currency:'EUR':'symbol':'1.2-2':'es' }}</td>
            <td>{{ getPositivePercentage(summaryResult.grossMargin, summaryResult.income) | percent:'1.0-0' }}</td>
          </tr>
          <tr>
            <td>Otros Ingresos Operativos</td>
            <td style="text-align:right;font-variant-numeric:tabular-nums">{{ summaryResult.otherOperatingIncome | currency:'EUR':'symbol':'1.2-2':'es' }}</td>
            <td style="text-align:right"></td>
          </tr>
          <tr>
            <td>Otros Gastos Operativos</td>
            <td style="text-align:right;font-variant-numeric:tabular-nums">{{ summaryResult.otherOperatingExpenses | currency:'EUR':'symbol':'1.2-2':'es' }}</td>
            <td style="text-align:right;color:#6b7280">{{ getPositivePercentage(summaryResult.otherOperatingExpenses, summaryResult.income + summaryResult.otherOperatingIncome) | percent:'1.0-0' }}</td>
          </tr>
          <tr>
            <td>Gastos del personal</td>
            <td style="text-align:right;font-variant-numeric:tabular-nums">{{ summaryResult.personnelExpenses | currency:'EUR':'symbol':'1.2-2':'es' }}</td>
            <td style="text-align:right;color:#6b7280">{{ getPositivePercentage(summaryResult.personnelExpenses, summaryResult.income + summaryResult.otherOperatingIncome) | percent:'1.0-0' }}</td>
          </tr>
          <tr class="fin-table__result">
            <td>EBITDA</td>
            <td>{{ summaryResult.ebitda | currency:'EUR':'symbol':'1.2-2':'es' }}</td>
            <td>{{ getPositivePercentage(summaryResult.ebitda, summaryResult.income + summaryResult.otherOperatingIncome) | percent:'1.0-0' }}</td>
          </tr>
          <tr>
            <td>Depreciaciones / Amortizaciones</td>
            <td style="text-align:right;font-variant-numeric:tabular-nums">{{ summaryResult.amortization | currency:'EUR':'symbol':'1.2-2':'es' }}</td>
            <td style="text-align:right;color:#6b7280">{{ getPositivePercentage(summaryResult.amortization, summaryResult.income + summaryResult.otherOperatingIncome) | percent:'1.0-0' }}</td>
          </tr>
          <tr class="fin-table__result">
            <td>Resultado operativo</td>
            <td>{{ summaryResult.operatingIncome | currency:'EUR':'symbol':'1.2-2':'es' }}</td>
            <td>{{ getPositivePercentage(summaryResult.operatingIncome, summaryResult.income + summaryResult.otherOperatingIncome) | percent:'1.0-0' }}</td>
          </tr>
          <tr>
            <td>Resultados extraordinarios</td>
            <td style="text-align:right;font-variant-numeric:tabular-nums">{{ summaryResult.extraordinaryResults | currency:'EUR':'symbol':'1.2-2':'es' }}</td>
            <td style="text-align:right;color:#6b7280">{{ getPositivePercentage(summaryResult.extraordinaryResults, summaryResult.income + summaryResult.otherOperatingIncome) | percent:'1.0-0' }}</td>
          </tr>
          <tr class="fin-table__result">
            <td>EBIT</td>
            <td>{{ summaryResult.ebit | currency:'EUR':'symbol':'1.2-2':'es' }}</td>
            <td>{{ getPositivePercentage(summaryResult.ebit, summaryResult.income + summaryResult.otherOperatingIncome) | percent:'1.0-0' }}</td>
          </tr>
          <tr>
            <td>Resultado Financiero</td>
            <td style="text-align:right;font-variant-numeric:tabular-nums">{{ summaryResult.financialResult | currency:'EUR':'symbol':'1.2-2':'es' }}</td>
            <td style="text-align:right;color:#6b7280">{{ getPositivePercentage(summaryResult.financialResult, summaryResult.income + summaryResult.otherOperatingIncome) | percent:'1.0-0' }}</td>
          </tr>
          <tr class="fin-table__result">
            <td>B.A.I.</td>
            <td>{{ summaryResult.profitBeforeTax | currency:'EUR':'symbol':'1.2-2':'es' }}</td>
            <td>{{ getPositivePercentage(summaryResult.profitBeforeTax, summaryResult.income + summaryResult.otherOperatingIncome) | percent:'1.0-0' }}</td>
          </tr>
          <tr>
            <td>Impuesto sobre beneficios</td>
            <td style="text-align:right;font-variant-numeric:tabular-nums">{{ summaryResult.incomeTax | currency:'EUR':'symbol':'1.2-2':'es' }}</td>
            <td style="text-align:right;color:#6b7280">{{ getPositivePercentage(summaryResult.incomeTax, summaryResult.income + summaryResult.otherOperatingIncome) | percent:'1.0-0' }}</td>
          </tr>
          <tr class="fin-table__key-result">
            <td>RESULTADO NETO</td>
            <td>{{ summaryResult.netIncome | currency:'EUR':'symbol':'1.2-2':'es' }}</td>
            <td>{{ getPositivePercentage(summaryResult.netIncome, summaryResult.income + summaryResult.otherOperatingIncome) | percent:'1.0-0' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>

</div>
